export const listDifference = (
	list1: string[],
	list2: string[],
): [string[], string[]] => {
	let inFirstNotInSecond = list1.filter((x) => !list2.includes(x));
	let inSecondNotInFirst = list2.filter((x) => !list1.includes(x));

	return [inFirstNotInSecond, inSecondNotInFirst];
};
